import { EventBus } from "@core/domain/models/event-bus.model";
import type { EventBusRepository } from "@core/domain/repositories/event-bus.repository.ts";
import { injectable } from "inversify";
import { Observable, Subject } from "rxjs";

@injectable()
export class EventBusImplRepository implements EventBusRepository {
    // DO NOT ADD DEPENDENCIES HERE

    private _bus = new Subject<EventBus>();

    get bus(): Observable<EventBus> {
        return this._bus.asObservable();
    }

    emit(event: EventBus): void {
        this._bus.next(event);
    }
}
